module.exports = __webpack_public_path__ + "static/media/Footerethereum.49557612.svg";